// Odczyt i zapis wspólnego wyboru nagłówka w preferencjach użytkownika (tabela `preferences`,
// scope=user) przez /api/preferences. Błędy są ciche: nagłówek działa wtedy na wartościach domyślnych.

import { normalizujWybor, type WspolnyWybor } from './wybor'

export const PREFERENCJA_NAGLOWKA = 'platforma.naglowek'

/** Po tylu ms bez odpowiedzi odczyt uznajemy za nieudany (nagłówek startuje z wartości domyślnych). */
export const LIMIT_ODCZYTU_MS = 4000

export type Pobierz = (url: string, init?: RequestInit) => Promise<Response>

/**
 * Zapytania do preferencji z tokenem logowania, bez obsługi 401/403 modułu: `authenticatedFetch` modułów
 * przy 401/403 czyści token i przenosi do logowania, a odmowa zapisu ustawień nagłówka (np. starszy
 * portal-api) nie może wylogować użytkownika.
 */
export function pobierzZTokenem(token: () => string | null, f: typeof fetch = (...a) => fetch(...a)): Pobierz {
  return (url, init = {}) => {
    const naglowki = new Headers(init.headers)
    const t = token()
    if (t) naglowki.set('Authorization', `Bearer ${t}`)
    return f(url, { credentials: 'include', ...init, headers: naglowki })
  }
}

export async function wczytajWybor(pobierz: Pobierz, adres: string, { limitMs = LIMIT_ODCZYTU_MS } = {}): Promise<WspolnyWybor | null> {
  let zegar: ReturnType<typeof setTimeout> | undefined
  const limit = new Promise<null>((r) => { zegar = setTimeout(() => r(null), limitMs) })
  const odczyt = (async () => {
    try {
      const r = await pobierz(`${adres}?namespace=${PREFERENCJA_NAGLOWKA}`, { method: 'GET', cache: 'no-store' })
      if (!r.ok) return null
      const body = (await r.json()) as { value?: unknown }
      const v = body?.value
      if (!v || typeof v !== 'object' || Object.keys(v as object).length === 0) return null
      return normalizujWybor(v)
    } catch {
      return null
    }
  })()
  try {
    return await Promise.race([odczyt, limit])
  } finally {
    clearTimeout(zegar)
  }
}

export async function zapiszWybor(pobierz: Pobierz, adres: string, w: WspolnyWybor): Promise<boolean> {
  try {
    const r = await pobierz(adres, {
      method: 'PUT',
      // Zapis wysłany przy chowaniu karty albo przejściu do innego modułu ma dojść mimo zamknięcia strony.
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ namespace: PREFERENCJA_NAGLOWKA, scope: 'user', key: 'default', value: w }),
    })
    return r.ok
  } catch {
    return false
  }
}
